unit View.Status_Titulos.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils;

type
  TFViewStatus_TitulosList = class(TForm)
    btNew: TButton;
    Status_TitulosDataset: TXDataWebDataSet;
    Status_TitulosDatasetid: TIntegerField;
    Status_TitulosDatasetnome: TStringField;
    Status_TitulosDatasetpermite_alterar: TBooleanField;
    Status_TitulosDatasetpermite_baixar: TBooleanField;
    Status_TitulosDatasetexcluido: TBooleanField;
    Status_TitulosDatasetinclusao: TDateTimeField;
    Status_TitulosDatasetalteracao: TDateTimeField;
    Status_TitulosDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchChange(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewStatus_TitulosList: TFViewStatus_TitulosList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewStatus_TitulosList }

procedure TFViewStatus_TitulosList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewStatus_TitulosList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewStatus_TitulosList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewStatus_TitulosList, AElementID, Result, @AfterCreate);
end;

procedure TFViewStatus_TitulosList.edSearchChange(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewStatus_TitulosList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewStatus_TitulosList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      Status_TitulosDataset.Connection.Model.DefaultSchema.FindEntityType(Status_TitulosDataset.EntitySetName),
      Status_TitulosDataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewStatus_TitulosList.WebFormCreate(Sender: TObject);
begin
  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    Status_TitulosDataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewStatus_TitulosList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.status_titulos.list.pagination.info');
  btNew := TButton.Create('view.status_titulos.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.status_titulos.list.table');
  cbPageSize := TComboBox.Create('view.status_titulos.list.cbPageSize');
  edSearch := TEdit.Create('view.status_titulos.list.search');
  lcPaginator := TListControl.Create('view.status_titulos.list.pagination');
  Status_TitulosDataset := TXDataWebDataSet.Create(Self);
  Status_TitulosDatasetid := TIntegerField.Create(Self);
  Status_TitulosDatasetnome := TStringField.Create(Self);
  Status_TitulosDatasetpermite_alterar := TBooleanField.Create(Self);
  Status_TitulosDatasetpermite_baixar := TBooleanField.Create(Self);
  Status_TitulosDatasetexcluido := TBooleanField.Create(Self);
  Status_TitulosDatasetinclusao := TDateTimeField.Create(Self);
  Status_TitulosDatasetalteracao := TDateTimeField.Create(Self);
  Status_TitulosDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  Status_TitulosDataset.BeforeLoadDFMValues;
  Status_TitulosDatasetid.BeforeLoadDFMValues;
  Status_TitulosDatasetnome.BeforeLoadDFMValues;
  Status_TitulosDatasetpermite_alterar.BeforeLoadDFMValues;
  Status_TitulosDatasetpermite_baixar.BeforeLoadDFMValues;
  Status_TitulosDatasetexcluido.BeforeLoadDFMValues;
  Status_TitulosDatasetinclusao.BeforeLoadDFMValues;
  Status_TitulosDatasetalteracao.BeforeLoadDFMValues;
  Status_TitulosDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  try
    Name := 'FViewStatus_TitulosList';
    Left := 0;
    Top := 0;
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.Transparent := True;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.TabOrder := 0;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nome';
      Title := 'nome';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'permite_alterar';
      Title := 'permite_alterar';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'permite_baixar';
      Title := 'permite_baixar';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'excluido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'alteracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'exclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Actions';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.TabOrder := 3;
    SetEvent(edSearch, Self, 'OnChange', 'edSearchChange');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    Status_TitulosDataset.SetParentComponent(Self);
    Status_TitulosDataset.Name := 'Status_TitulosDataset';
    Status_TitulosDataset.EntitySetName := 'Status_Titulos';
    Status_TitulosDataset.Connection := DMConnection.ApiConnection;
    Status_TitulosDataset.Left := 72;
    Status_TitulosDataset.Top := 144;
    Status_TitulosDatasetid.SetParentComponent(Status_TitulosDataset);
    Status_TitulosDatasetid.Name := 'Status_TitulosDatasetid';
    Status_TitulosDatasetid.FieldName := 'id';
    Status_TitulosDatasetid.Required := True;
    Status_TitulosDatasetnome.SetParentComponent(Status_TitulosDataset);
    Status_TitulosDatasetnome.Name := 'Status_TitulosDatasetnome';
    Status_TitulosDatasetnome.FieldName := 'nome';
    Status_TitulosDatasetnome.Required := True;
    Status_TitulosDatasetnome.Size := 255;
    Status_TitulosDatasetpermite_alterar.SetParentComponent(Status_TitulosDataset);
    Status_TitulosDatasetpermite_alterar.Name := 'Status_TitulosDatasetpermite_alterar';
    Status_TitulosDatasetpermite_alterar.FieldName := 'permite_alterar';
    Status_TitulosDatasetpermite_alterar.Required := True;
    Status_TitulosDatasetpermite_baixar.SetParentComponent(Status_TitulosDataset);
    Status_TitulosDatasetpermite_baixar.Name := 'Status_TitulosDatasetpermite_baixar';
    Status_TitulosDatasetpermite_baixar.FieldName := 'permite_baixar';
    Status_TitulosDatasetpermite_baixar.Required := True;
    Status_TitulosDatasetexcluido.SetParentComponent(Status_TitulosDataset);
    Status_TitulosDatasetexcluido.Name := 'Status_TitulosDatasetexcluido';
    Status_TitulosDatasetexcluido.FieldName := 'excluido';
    Status_TitulosDatasetexcluido.Required := False;
    Status_TitulosDatasetinclusao.SetParentComponent(Status_TitulosDataset);
    Status_TitulosDatasetinclusao.Name := 'Status_TitulosDatasetinclusao';
    Status_TitulosDatasetinclusao.FieldName := 'inclusao';
    Status_TitulosDatasetinclusao.Required := False;
    Status_TitulosDatasetalteracao.SetParentComponent(Status_TitulosDataset);
    Status_TitulosDatasetalteracao.Name := 'Status_TitulosDatasetalteracao';
    Status_TitulosDatasetalteracao.FieldName := 'alteracao';
    Status_TitulosDatasetalteracao.Required := False;
    Status_TitulosDatasetexclusao.SetParentComponent(Status_TitulosDataset);
    Status_TitulosDatasetexclusao.Name := 'Status_TitulosDatasetexclusao';
    Status_TitulosDatasetexclusao.FieldName := 'exclusao';
    Status_TitulosDatasetexclusao.Required := False;
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := Status_TitulosDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    Status_TitulosDataset.AfterLoadDFMValues;
    Status_TitulosDatasetid.AfterLoadDFMValues;
    Status_TitulosDatasetnome.AfterLoadDFMValues;
    Status_TitulosDatasetpermite_alterar.AfterLoadDFMValues;
    Status_TitulosDatasetpermite_baixar.AfterLoadDFMValues;
    Status_TitulosDatasetexcluido.AfterLoadDFMValues;
    Status_TitulosDatasetinclusao.AfterLoadDFMValues;
    Status_TitulosDatasetalteracao.AfterLoadDFMValues;
    Status_TitulosDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
  end;
end;

end.
